import * as v from 'valibot';

import { maoTripLegSchema } from './maoTripLeg.schema';

import type { MaoTrip } from '../types';

// BE returns Legs in unspecified order. Sort by OffBlocksUtcUnix (with
// OnBlocksUtcUnix as a tiebreaker) so downstream consumers can rely on
// chronological order regardless of whether SectorIndex exists.
export const maoTripSchema: v.GenericSchema<MaoTrip> = v.pipe(
  v.object({
    Legs: v.array(maoTripLegSchema, 'Trip legs are missing'),
    Id: v.number('Trip ID is missing'),
    ExternalReference: v.string('External reference is missing'),
    TripStartUnix: v.number('Trip start unix is missing'),
    TripEndUnix: v.number('Trip end unix is missing'),
  }),
  v.transform(trip => ({
    ...trip,
    Legs: [...trip.Legs].sort(
      (a, b) =>
        a.OffBlocksUtcUnix - b.OffBlocksUtcUnix ||
        a.OnBlocksUtcUnix - b.OnBlocksUtcUnix,
    ),
  })),
);
